import type { CanvasItem, HybridClock, Space } from "@bedrock/domain";

const createdAt = 1_750_000_000_000;
const clock: HybridClock = { wallTime: createdAt, counter: 0, deviceId: "bedrock-seed" };

export const fixtureSpaces: Space[] = [
  { id: "space-field-notes", title: "Field notes", theme: "light", starred: false, fieldClocks: {}, createdAt, updatedAt: createdAt + 3, deletedAt: null },
  { id: "space-home", title: "A slower home", theme: "light", starred: false, fieldClocks: {}, createdAt, updatedAt: createdAt + 2, deletedAt: null },
  { id: "space-reading", title: "Reading room", theme: "dark", starred: false, fieldClocks: {}, createdAt, updatedAt: createdAt + 1, deletedAt: null }
];

function base(id: string, spaceId: string, x: number, y: number, width: number, height: number, zIndex: number): Omit<CanvasItem, "type" | "props"> {
  return { id, spaceId, x, y, width, height, rotation: 0, zIndex, parentStackId: null, fieldClocks: {}, createdAt, updatedAt: createdAt, deletedAt: null };
}

export const fixtureItems: CanvasItem[] = [
  {
    ...base("label-atmosphere", "space-field-notes", -560, -390, 410, 112, 1),
    type: "label",
    props: { kind: "label", text: "A study of quiet places", size: "large" }
  },
  {
    ...base("note-observation", "space-field-notes", -520, -260, 285, 220, 3),
    rotation: -1.4,
    type: "sticky-note",
    props: { kind: "sticky-note", markdown: "## Observation\n\nThe useful details appear after the room becomes ordinary.", plainText: "Observation The useful details appear after the room becomes ordinary.", accent: "cyan" }
  },
  {
    ...base("image-field", "space-field-notes", -130, -300, 390, 290, 2),
    rotation: 1.1,
    type: "image",
    props: { kind: "image", assetId: "fixture-field", filename: "field-study.svg", mimeType: "image/svg+xml", alt: "An abstract original Bedrock field study", status: "ready", localUrl: "/media/field-study.svg" }
  },
  {
    ...base("document-method", "space-field-notes", 365, -265, 330, 440, 4),
    type: "document",
    props: { kind: "document", title: "Method for noticing", markdown: "# Method for noticing\n\nStart with what feels immovable. Record the light, the distance between objects, and what the room asks you to ignore.\n\n- Return at another hour\n- Keep the frame generous\n- Leave room for uncertainty\n\n> Attention is a material.", plainText: "Method for noticing Start with what feels immovable. Record the light, the distance between objects, and what the room asks you to ignore. Return at another hour. Keep the frame generous. Leave room for uncertainty. Attention is a material.", color: "paper" }
  },
  {
    ...base("note-palette", "space-field-notes", -380, 110, 250, 180, 5),
    rotation: .8,
    type: "sticky-note",
    props: { kind: "sticky-note", markdown: "**Palette**\n\nstone / lichen / washed sky", plainText: "Palette stone lichen washed sky", accent: "green" }
  },
  {
    ...base("clip-journal", "space-field-notes", -40, 95, 350, 230, 6),
    type: "web-clip",
    props: { kind: "web-clip", clipId: "fixture-clip", url: "https://example.com/field-journal", title: "The architecture of attention", description: "Notes on slow observation and the spaces that teach us how to look.", siteName: "FIELD JOURNAL", status: "ready", previewAssetId: null }
  },
  {
    ...base("stack-sources", "space-field-notes", 440, 275, 280, 205, 7),
    type: "stack",
    props: { kind: "stack", title: "Sources", collapsed: true, color: "lilac" }
  },
  {
    ...base("home-label", "space-home", -320, -230, 480, 80, 1),
    type: "label",
    props: { kind: "label", text: "Make less, keep better", size: "large" }
  },
  {
    ...base("home-note", "space-home", -260, -80, 280, 230, 2),
    type: "sticky-note",
    props: { kind: "sticky-note", markdown: "## Saturday\n\n- [ ] repair the reading lamp\n- [ ] clear the north shelf\n- [x] bring in rosemary", plainText: "Saturday repair the reading lamp clear the north shelf bring in rosemary", accent: "orange" }
  },
  {
    ...base("reading-document", "space-reading", -160, -260, 350, 500, 1),
    type: "document",
    props: { kind: "document", title: "Marginalia", markdown: "# Marginalia\n\nA private list of sentences worth returning to.\n\n`Read slowly; keep the friction.`", plainText: "Marginalia A private list of sentences worth returning to. Read slowly keep the friction.", color: "paper" }
  }
];

export const fixtureClock = clock;
